import { render, staticRenderFns } from "./MaterialItemBank.vue?vue&type=template&id=5ac44468&"
import script from "./MaterialItemBank.vue?vue&type=script&lang=js&"
export * from "./MaterialItemBank.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports